<section id="contato" class="relative overflow-hidden bg-primary py-24 lg:py-32">
  <div class="site-container relative z-10 grid grid-cols-1 items-center gap-16 lg:grid-cols-2 lg:gap-24">
    <div class="text-white">
      <h2 class="mb-8 text-4xl leading-tight font-bold text-white lg:text-5xl">{{ content.title }}</h2>
      <p class="mb-12 text-xl text-navy-200">{{ content.description }}</p>
      <div class="rounded-lg border border-white/10 bg-white/5 p-6">
        <span class="mb-2 block font-accent text-lg text-gold">{{ content.sealTitle }}</span>
        <p class="text-xs italic opacity-80">{{ content.sealText }}</p>
      </div>
    </div>

    <div class="rounded-xl bg-surface p-8 shadow-2xl lg:p-10">
      @if (status() === 'sent') {
        <div class="space-y-4 text-center" role="status">
          <p class="font-display text-2xl font-bold text-primary">Solicitação enviada!</p>
          <p class="text-muted">Recebemos seus dados e nossa equipe entrará em contato em breve.</p>
          <button type="button" class="font-bold text-primary hover:text-gold" (click)="status.set('idle')">
            Enviar outra solicitação
          </button>
        </div>
      } @else {
        <form class="space-y-6" [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <!-- Campo isca contra robôs: oculto para pessoas e leitores de tela -->
          <div class="absolute -left-[9999px]" aria-hidden="true">
            <label for="demo-website">Site</label>
            <input id="demo-website" type="text" formControlName="website" tabindex="-1" autocomplete="off" />
          </div>

          <div>
            <label for="demo-name" class="mb-1 block text-[10px] font-black tracking-widest text-primary uppercase">Nome Completo</label>
            <input
              id="demo-name"
              type="text"
              formControlName="name"
              autocomplete="name"
              placeholder="Seu nome"
              class="field"
              [attr.aria-invalid]="showError('name')"
              [attr.aria-describedby]="showError('name') ? 'demo-name-error' : null"
            />
            @if (showError('name')) {
              <p id="demo-name-error" class="field-error">Informe seu nome completo.</p>
            }
          </div>

          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <label for="demo-email" class="mb-1 block text-[10px] font-black tracking-widest text-primary uppercase">E-mail Corporativo</label>
              <input
                id="demo-email"
                type="email"
                formControlName="email"
                autocomplete="email"
                placeholder="email@instituicao.com.br"
                class="field"
                [attr.aria-invalid]="showError('email')"
                [attr.aria-describedby]="showError('email') ? 'demo-email-error' : null"
              />
              @if (showError('email')) {
                <p id="demo-email-error" class="field-error">Informe um e-mail válido.</p>
              }
            </div>
            <div>
              <label for="demo-phone" class="mb-1 block text-[10px] font-black tracking-widest text-primary uppercase">
                Telefone <span class="font-bold tracking-normal text-muted normal-case">(opcional)</span>
              </label>
              <input
                id="demo-phone"
                type="tel"
                inputmode="tel"
                formControlName="phone"
                autocomplete="tel"
                placeholder="(11) 91234-5678"
                class="field"
                [attr.aria-invalid]="showError('phone')"
                [attr.aria-describedby]="showError('phone') ? 'demo-phone-error' : null"
              />
              @if (showError('phone')) {
                <p id="demo-phone-error" class="field-error">Informe um telefone com DDD.</p>
              }
            </div>
          </div>

          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <label for="demo-institution" class="mb-1 block text-[10px] font-black tracking-widest text-primary uppercase">Instituição</label>
              <input
                id="demo-institution"
                type="text"
                formControlName="institution"
                autocomplete="organization"
                placeholder="Hospital"
                class="field"
                [attr.aria-invalid]="showError('institution')"
                [attr.aria-describedby]="showError('institution') ? 'demo-institution-error' : null"
              />
              @if (showError('institution')) {
                <p id="demo-institution-error" class="field-error">Informe a instituição.</p>
              }
            </div>
            <div>
              <label for="demo-role" class="mb-1 block text-[10px] font-black tracking-widest text-primary uppercase">Cargo</label>
              <input
                id="demo-role"
                type="text"
                formControlName="role"
                autocomplete="organization-title"
                placeholder="Diretor Clínico"
                class="field"
                [attr.aria-invalid]="showError('role')"
                [attr.aria-describedby]="showError('role') ? 'demo-role-error' : null"
              />
              @if (showError('role')) {
                <p id="demo-role-error" class="field-error">Informe seu cargo.</p>
              }
            </div>
          </div>

          <div>
            <label class="flex items-start gap-3 text-xs text-muted">
              <input type="checkbox" formControlName="consent" class="mt-0.5 size-4 shrink-0 accent-primary" />
              <span>
                Concordo com o uso dos meus dados para contato comercial, conforme a
                <a routerLink="/privacy-policy" class="font-bold text-primary underline">Política de privacidade</a>.
              </span>
            </label>
            @if (showError('consent')) {
              <p class="field-error">É necessário concordar para continuar.</p>
            }
          </div>

          @if (status() === 'error') {
            <p class="rounded border border-danger/30 bg-danger/10 p-3 text-sm text-danger" role="alert">
              Não foi possível enviar agora. Tente novamente em instantes ou escreva para
              <a [href]="'mailto:' + contactEmail" class="font-bold underline">{{ contactEmail }}</a>.
            </p>
          }

          <button
            type="submit"
            class="w-full rounded bg-primary py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-primary-hover disabled:cursor-wait disabled:opacity-70"
            [disabled]="status() === 'sending'"
          >
            {{ status() === 'sending' ? 'Enviando…' : content.submit }}
          </button>
        </form>
      }
    </div>
  </div>
  <div class="absolute top-0 right-0 h-full w-1/2 bg-linear-to-l from-gold/10 to-transparent"></div>
</section>
